export default __webpack_public_path__ + "static/media/flag-antigua-and-barbuda.b0585f3b.svg";